export default {"src":"/_next/static/media/banner.4ec45bd1.svg","height":301,"width":745,"blurWidth":0,"blurHeight":0};